import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import { SortTypes } from '../enums/SortTypes';
import EmployeesQueueHeaderSortLink from './EmployeesQueueHeaderSortLink';
 
const EmployeesQueueTableColumnHeader = ({ queue, sort, onSortChanged }) => {
    const [reversed, setReversed] = useState(false);

    useEffect(() => {
        if (queue) {
            if (queue.reversed !== reversed) {
                setReversed(queue.reversed)
            }
        } else {
            setReversed(false);
        }
    }, [queue])

    const handleSort = (sortValue, reversed) => {
        onSortChanged(sortValue, reversed)
    }

    return (
        <div className="columns">
            <div className='column is-3 pl-5'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.CLIENT_NAME} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='OfficesPage.Summary.Client' />
                </EmployeesQueueHeaderSortLink>
            </div>            
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.NEW} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='OfficesPage.Summary.New' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.IN_PROGRESS} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='OfficesPage.Summary.InProgress' />
                </EmployeesQueueHeaderSortLink>                
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.COMPLETED} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='OfficesPage.Summary.Completed' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-2'>
                <EmployeesQueueHeaderSortLink sort={sort} sortValue={SortTypes.AVG_COMPLETION} reversed={reversed} onSortChanged={handleSort}>
                    <HrbTranslate text='OfficesPage.Summary.AvgCompletion' />
                </EmployeesQueueHeaderSortLink>
            </div>
            <div className='column is-1'></div>
        </div>
    );
        }

EmployeesQueueTableColumnHeader.propTypes = {
    queue: PropTypes.object,
    sort: PropTypes.string,
    onSortChanged: PropTypes.func.isRequired
}

export default EmployeesQueueTableColumnHeader